<template>
    <div id="tab-3">
        <TabLabel
            text="Почтовый адрес"
            number="3"
            :isCompleted="tabCompleted"
            @edit="openCurrentTab"
            :isAdmin="isAdmin"
        />
        <ContainerSlot :isCompleted="tabActive === 'tab-3'" v-if="localData">
            <v-form @submit="addTab" id="form-tab-3">
                <div class="input-container">
                    <div class="input-block order-1">
                        <v-input
                            name="region"
                            title="Страна, город"
                            rules="required"
                            v-model="localData.region"
                            :disabled="disabled"
                        />
                    </div>
                    <div class="input-block order-4">
                        <v-input
                            name="mailbox"
                            title="Абонентский ящик (опционально)"
                            v-model="localData.mailbox"
                            :disabled="disabled"
                        />
                    </div>

                    <div class="input-block order-2">
                        <v-input
                            name="street"
                            title="Улица"
                            rules="required"
                            v-model="localData.street"
                            :disabled="disabled"
                        />
                    </div>
                    <div class="input-block order-5">
                        <v-input
                            name="postcode"
                            title="Индекс"
                            rules="required"
                            v-model="localData.postcode"
                            :disabled="disabled"
                        />
                    </div>

                    <div class="input-block order-3">
                        <div class="input-block half">
                            <v-input
                                name="house_number"
                                title="Дом"
                                rules="required"
                                v-model="localData.house_number"
                                :disabled="disabled"
                            />
                        </div>
                        <div class="input-block half">
                            <v-input
                                name="flat_number"
                                title="Квартира"
                                rules="required"
                                v-model="localData.flat_number"
                                :disabled="disabled"
                            />
                        </div>
                    </div>
                </div>
            </v-form>
            <v-btn v-if="!hideButton" form="form-tab-3">{{ !tabCompleted ? "Далее" : "Сохранить" }}</v-btn>
        </ContainerSlot>
    </div>
</template>

<script>
export default {
    name: "tab-3",
    $_veeValidate: {
        validator: "new"
    },
    data() {
        return {
            localData: null
        };
    },
    components: {
        TabLabel: () => import("../UI/TabLabel"),
        ContainerSlot: () => import("../UI/ContainerSlot")
    },
    props: {
        tabCompleted: {
            required: true
        },
        deleteCompleteTab: Function,
        addCompleteTab: Function,
        saveStepData: Function,
        setEditTab: Function,
        tabActive: String,
        stepData: Object,
        hideButton: {
            default: false
        },
        disabled: {
            default: false
        },
        isAdmin: {
            default: false
        }
    },
    created() {
        this.localData = { ...this.stepData };
    },
    watch: {
        tabActive(val) {
            if (val === "tab-3") {
                this.localData = { ...this.stepData };
            } else {
                this.saveStepData("stepData_3", this.localData);
            }
        }
    },
    methods: {
        openCurrentTab() {
            this.setEditTab("tab-3");
        },
        addTab() {
            this.validate().then(() => {
                this.addCompleteTab("tab-3", "stepData_3", this.localData);
            });
        }
    }
};
</script>

<style lang="scss">
#tab-3 {
}
</style>
